import React from 'react';
import { Carousel, Clickable } from 'phoenix-components';
import trustedLogo from 'assets/logos/trustedlogo.svg';
import windoLogo from 'assets/logos/windoLogo.svg';
import starFilled from 'assets/v2/login/slider/starFilled.svg';
import countries from 'assets/v2/login/slider/countries.svg';
import sellers from 'assets/v2/login/slider/sellers.svg';
import orders from 'assets/v2/login/slider/orders.svg';
import { useDesktop } from 'contexts';
import { useQueryParams } from 'hooks';
import { useHistory } from 'react-router-dom';
import langIcon from 'assets/v2/login/buttons/lang.svg';
import { LanguageDrawer } from '../common/LanguageDrawer';
import styles from './Slider.module.css';

const slides = [
  {
    title: 'Black Lovers',
    stars: 5,
    content: 'Hi, I\'m from The Black lovers store, I launched my website officially to my customers on Feb 8, '
        + '2023. It\'s been one week.I have received 100+ original real orders and '
        + 'I have dispatched many with the help of your Customer payment feature. '
        + ' I\'m receiving payments directly to my bank accounts',
  },
  {
    title: 'LIEW CHIEW NGO',
    stars: 5,
    content: 'I have used many other platforms but I gave up and then I joined Windo; '
        + 'it is so easy to use and there is no distraction. '
        + 'I can directly see the options to Create Products.'
        + ' Even I can import the Products from Instagram, which is super easy',
  },
  {
    title: 'Shaik Abdulla',
    stars: 5,
    content: 'Guys, they are just awesome and super features compare to others, '
        + 'they are looting our money up to $98 but here they are, providing us with the same features, '
        + 'and charging $7/month only.',
  },
  {
    title: 'Jacquelyn B. Lantie',
    stars: 5,
    content: 'So far, it\'s been incredibly easy to use. I\'ve imported all my products in Bulk to create a catalogue,'
        + ' which is my favourite feature for sure.',
  },
  {
    title: 'Артём Зелинский',
    stars: 5,
    content: 'I rate it at 5 because there is more flexibility in adding Delivery &  Payment options,'
        + ' I can add any payment option I want in Custom payments',
  },
  {
    title: 'Craftzone',
    stars: 5,
    content: 'Recently I Converted my store into a Mobile application and my shop Visitors have increased and I have'
        + ' started getting orders. I really like this feature, and now '
        + 'I don\'t have to send the Shop link again to my customers.'
        + ' They can install the app & they can visit whenever they want.',
  }
];
const desktopSlides = [
  {
    title: 'Black Lovers',
    stars: 5,
    content: 'Hi, I\'m from The Black lovers store, I launched my website officially to my customers on Feb 8, '
        + '2023. It\'s been one week.I have received 100+ original real orders and '
        + 'I have dispatched many with the help of your Customer payment feature. '
        + ' I\'m receiving payments directly to my bank accounts',
  },
  {
    title: 'Shaik Abdulla',
    stars: 5,
    content: 'Guys, they are just awesome and super features compare to others, '
        + 'they are looting our money up to $98 but here they are, providing us with the same features, '
        + 'and charging $7/month only.',
  },
  {
    title: 'Craftzone',
    stars: 5,
    content: 'Recently I Converted my store into a Mobile application and my shop Visitors have increased and I have'
        + ' started getting orders. I really like this feature, and now '
        + 'I don\'t have to send the Shop link again to my customers.'
        + ' They can install the app & they can visit whenever they want.',
  }
];
export function Slider() {
  const isDesktop = useDesktop();
  const params = useQueryParams();
  const history = useHistory();
  const openLanguage = params.get('lang') === 'true';
  const toggleScreen = (screen) => {
    if (params.get(screen) === 'true') {
      history.goBack();
      return;
    }
    params.set(screen, 'true');
    history.push({ search: params.toString() });
  };

  const toggleLanguage = () => toggleScreen('lang');
  const items = isDesktop ? desktopSlides : slides;

  return (
    <>
      {!isDesktop && (
        <>
          <div className={styles.head}>
            <img src={windoLogo} alt="" />
            <Clickable
              dataId="silder-changelanguage"
              className={styles.selectLang}
              onClick={toggleLanguage}
            >
              <img src={langIcon} alt="" />
              <div className={styles.lang}>
                Change Language
              </div>
            </Clickable>
          </div>
          <div className={styles.trustedLogo}>
            <img src={trustedLogo} alt="" />
            <div className={styles.trustedTxt}>
              Trusted by 350,000+ Sellers, 140+ Countries,
              <br />
              1Million+ Orders Processed
            </div>
          </div>
          {openLanguage && <LanguageDrawer onBack={toggleLanguage} />}
          <Carousel
            showStatus={false}
            showArrows={false}
            autoPlay={true}
            interval={10000}
            infiniteLoop={true}
            showIndicators={true}
            showThumbs={false}
            swipeable={true}
          >
            {items.map(((slide, idx) => (
              <div key={idx} className={styles.item}>
                <div className={styles.image}>
                  {slide.title}
                </div>
                {slide.stars && (
                  <div className={styles.stars}>
                    {[...Array(slide.stars)].map((_, i) => (
                      <img key={i} src={starFilled} alt="star" />
                    ))}
                  </div>
                )}
                <div className={styles.content}>{slide.content}</div>
              </div>
            )))}
          </Carousel>
        </>
      )}
      {isDesktop && (
        <>
          <div className={styles.deskSlide}>
            <img src={countries} alt="countries" className={styles.countryImg} />
            <img src={sellers} alt="sellers" className={styles.sellersImg} />
            <img src={orders} alt="orders" className={styles.ordersImg} />
          </div>
          <div className={styles.secondContainer}>
            <div className={styles.Dimage}>
              Shaik Abdulla
            </div>
            <div className={styles.stars}>
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
            </div>
            <div className={styles.Dcontent}>
              Guys, they are just awesome and super features compare to others, they are looting our money up
              to $98 but here they are, providing us with the same features, and
              {' '}
              <b>charging $7/month only.</b>
            </div>
          </div>
          <div className={styles.thirdContainer}>
            <div className={styles.Dimage}>
              Craftzone
            </div>
            <div className={styles.stars}>
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
            </div>
            <div className={styles.Dcontent}>
              Recently
              {' '}
              <b>I Converted my store into a Mobile application</b>
              {' '}
              and my shop Visitors have increased and
              I have started getting orders. I really like this feature, and now I don't have to send the Shop
              link again to my customers. They can install the app & they can visit whenever they want.
            </div>
          </div>
          <div className={styles.firstContainer}>
            <div className={styles.Dimage}>
              Black Lovers
            </div>
            <div className={styles.stars}>
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
              <img src={starFilled} alt="star" />
            </div>
            <div className={styles.Dcontent}>
              Hi, I'm from The Black lovers store, I launched my website officially to my customers on Feb 8, 2023.
              It's been one week.  I have received 100+ original real orders and I have dispatched many with the
              help of your
              {' '}
              <b>Customer payment feature.</b>
              {' '}
              I'm receiving payments directly to my bank accounts.
            </div>
          </div>
        </>
      )}
    </>
  );
}

Slider.propTypes = {};

Slider.defaultProps = {};
